module.exports = __webpack_public_path__ + "img/slide-text.66a3bc47.svg";